<template>
    <HeroCarousel :slidesBackground="slides.background">
        <template v-for="i in slidesNumber" #[`slide${i}`]>
            <TotemIntro :type="slides.introType[i-1]" v-on:on-play-video="openVideoModal()">
                <template #title>
                    <span v-html="$t('Hero.slide_' + i + '_title_' + $totemLang)"></span>
                </template>
                <template #description>
                    <span v-html="$t('Hero.slide_' + i + '_description_' + $totemLang)"></span>
                </template>
                <template #buttons>
                    <TotemRouterLink
                        color="hero"
                        :to="slides.buttonLink[i-1]"
                        :label="$t('Hero.slide_' + i + '_button_' + $totemLang)"
                    />
                    <TotemRouterLink
                        color="transparent"
                        :to="slides.secondaryButtonLink[i-1]"
                        :label="$t('Hero.slide_' + i + '_button_secondary_' + $totemLang)"
                        v-if="translationExist('Hero.slide_' + i + '_button_secondary_' + $totemLang)"
                    />
                </template>
                <template #image>
                    <div class="intro__image-box">
                        <img :src="require('@/assets/images/hero/hero-image-0' + i + '-' + $totemLang +'.png')" alt="" class="intro__image"/>
                    </div>
                </template>
                <template #video>
                    <img :src="require('@/assets/images/hero/video-screen-0' + i + '-'+ $totemLang + '.png')" alt="" class="intro__video-thumbnail" @click="openVideoModal"/>
                </template>
            </TotemIntro>
        </template>
        <HeroVideoModal :videoSrc="slides.videoSrc" />
        </HeroCarousel>
</template>

<script>
    import HeroCarousel from 'components/landingpage/hero/HeroCarousel'
    import HeroVideoModal from '@/components/landingpage/hero/HeroVideoModal'
    import { heroDataHelper } from 'components/landingpage/hero/heroDataHelper'

    export default {
        name: 'hero-logged',
        components: { HeroCarousel, HeroVideoModal },
        mixins: [heroDataHelper]
    }
</script>
